import axios from 'axios'

/**
 * @desc Fetches all family groups for specified supplier
 *
 * @param {String} supplierId
 */
export const fetchFamilyGroups = (supplierId) =>
  axios
    .get(`/authenticated/family-group?supplierId=${supplierId}`)
    .then((res) => res.data)

/**
 * @desc Creates new family group for product
 *
 * @param {String} supplierId
 * @param {Object} familyGroup
 */
export const createFamilyGroup = (supplierId, familyGroup) =>
  axios
    .post(`/authenticated/family-group?supplierId=${supplierId}`, familyGroup)
    .then((res) => res.data)

/**
 * @desc Updates family group
 *
 * @param {String} familyGroupId
 * @param {Object} promotion
 */
export const updateFamilyGroup = (familyGroupId, familyGroup) =>
  axios
    .put(`/authenticated/family-group/${familyGroupId}`, familyGroup)
    .then((res) => res.data)

/**
 * @desc Deletes family group
 *
 * @param {String} familyGroupId
 */
export const deleteFamilyGroup = (familyGroupId) =>
  axios
    .delete(`/authenticated/family-group/${familyGroupId}`)
    .then((res) => res.data)

/**
 * @desc uploads new family group image
 */
export const uploadFamilyGroupImage = (familyGroupId, file) => {
  const formData = new FormData()
  formData.append('file', file)

  return axios
    .post(`/authenticated/family-group/${familyGroupId}/image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then((res) => res.data)
}
